import {
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { isAddress } from "ethers";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import TermsAndConditionsModal from "../../components/TermsAndConditionsModal.jsx";
import {Modal} from "../../components/Modal/index.jsx";
import termsData from "../../data.js";
import {
  setIsValidReferral,
  setReferralAddress,
} from "../../redux/data/dataSlice.js";
import {
  balanceOfFromContract,
  isValidReferralAddress,
} from "../../uniswap/utils.js";
import ConfirmNodeComponent from "../confirmNode/confirmNode.jsx";
import InputNode from "./components/InputNode.jsx";
import ProceedButton from "./components/ProceedButton.jsx";
import ReferralInput from "./components/ReferralInput.jsx";
import RulesAndTerms from "./components/RulesAndTerms.jsx";
import { useContextProvider } from '../../context/index.jsx';

const BuyNodeModal = ({ openModal, closeModal }) => {
	const {walletAddress}= useContextProvider();
  const dispatch = useDispatch();
  const referralAddress = useSelector((state) => state.data.referralAddress);
  const isValidReferral = useSelector((state) => state.data.isValidReferral);
  const [openConfirmNode, setOpenConfirmNode] = useState(false);
  const [nodesCount, setNodesCount] = useState(0);
  const [quantity, setQuantity] = useState(1); // Initial quantity for nodes
  const [isLoading, setIsLoading] = useState(false); // State to manage loading state
  const [checkBoxes, setCheckBoxes] = useState({
    terms1: false,
    terms2: false,
    terms3: false,
  });
  const [checkboxErrors, setCheckboxErrors] = useState({
    terms1: false,
    terms2: false,
    terms3: false,
  });
	const closeConfirmModal = () => {
    setOpenConfirmNode(false);
  };

  const handleIncrement = () => {
    console.log("nodesCount", nodesCount);

    if (quantity + nodesCount < 10) {
      console.log("Increment");

      setQuantity((prev) => prev + 1);
    }
  };

  const handleDecrement = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : prev)); // Prevent quantity from going below 1
  };

  const handleCheckboxChange = (name) => {
    setCheckBoxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: !prevCheckboxes[name],
    }));

    setCheckboxErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false,
    }));
  };

  const handleProceed = async (address) => {

    const newErrors = {
      terms1: !checkBoxes.terms1,
      terms2: !checkBoxes.terms2,
      terms3: !checkBoxes.terms3,
    };

    setCheckboxErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      toast.error("Please agree to all terms", { duration: 2000 });

      return;
    }

    if (isAddress(address)) {
      setIsLoading(true); // Start loading

      console.error("nodes Address", nodesCount);

      setOpenConfirmNode(true);
    } else {
      console.error("Invalid Address");

      toast.error("Invalid Address", { duration: 500 });
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(null);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleTermClick = (term) => {
    setSelectedTerm(term);

    setIsModalOpen(true);
  };

  const handleReferralInputChange = async (e) => {
    const newReferralAddress = e.target.value;

    dispatch(setReferralAddress(newReferralAddress));

    localStorage.setItem("referralAddress", newReferralAddress);

    try {
      const isValid = await verifyReferralWallet(newReferralAddress);

      dispatch(setIsValidReferral(isValid));
    } catch (error) {
      console.error("Error occurred while verifying referral wallet:", error);
    }
  };

  const verifyReferralWallet = async (referralAddress) => {
    try {
      if (isAddress(referralAddress)) {
        const isValid = await isValidReferralAddress(referralAddress);

        return isValid;
      }

      return false;
    } catch (error) {
      console.error("Error verifying referral wallet:", error);

      return false;
    }
  };

  useEffect(() => {
    const fetchNodesCount = async (walletAddress) => {
      const count = await balanceOfFromContract(walletAddress);

      setNodesCount(Number(count));
    };

    if (walletAddress) {
      fetchNodesCount(walletAddress);
    }
  }, [walletAddress]);

  const formattedNumber = () => {
    const total = Number(process.env.REACT_APP_NODE_PRICE) * quantity;

    return total.toLocaleString("en-US");
  };

  useEffect(() => {
    if (openModal) {
      document.body.classList.add("scroll-lock");
    } else {
      document.body.classList.remove("scroll-lock");
    }

    return () => {
      document.body.classList.remove("scroll-lock");
    };
  }, [openModal]);

  return (
    <>
      <Modal
        onClose={closeModal}
        isOpened={openModal}
      >
        <div className="pt-3 pb-4 flex items-center flex-col gap-3 border-b border-lightGrayBlue dark:border-darkSlateBlue">
          <InputNode
            handleDecrement={handleDecrement}
            handleIncrement={handleIncrement}
            quantity={quantity}
          />
          <p className="text-base leading-6 text-black dark:text-white">
            {`${formattedNumber()} USDT`}
          </p>
        </div>
        <RulesAndTerms
          checkBoxes={checkBoxes}
          handleCheckboxChange={handleCheckboxChange}
          checkboxErrors={checkboxErrors}
          handleTermClick={handleTermClick}
        />

        <ReferralInput
          referralAddress={referralAddress}
          handleReferralInputChange={handleReferralInputChange}
        />
        <div>
          {referralAddress && (
            <div>
              {isValidReferral ? (
                <p className="text-center py-1 text-[#5E6B89] text-[13px]">
                    Valid referral wallet address
                </p>
              ) : (
                <p className="text-center py-1 text-[#FF0000] text-[13px]">
                    Invalid referral wallet address
                </p>
              )}
            </div>
          )}
        </div>
        <ProceedButton
          isLoading={isLoading}
          isValidReferral={isValidReferral}
          checkBoxes={checkBoxes}
          handleProceed={handleProceed}
          referralAddress={referralAddress}
        />
      </Modal>

      <ConfirmNodeComponent
        isOpen={openConfirmNode}
        closeModal={closeConfirmModal}
        quantity={quantity}
        address={walletAddress}
      />
      <TermsAndConditionsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        termsData={termsData}
        selectedTerm={selectedTerm}
      />
    </>
  );
};

export default BuyNodeModal;
